(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.controller('WeekschemeTableController', ['$state', 'ItemTableService', WeekschemeTableControllerFn]);

    /* controlle for main week schemes */
    function WeekschemeTableControllerFn($state, ItemTableService) {
        var vm = this;

        // the service -> here the ItemTableService
        vm.overview = null;

        activate();


        // add new row to table
        vm.add = function () {
            var item = vm.overview.add();
            // set properties
            if (item) {
                item.isIndividual = vm.individual;
            } //if
        };

        // show all
        vm.showAll = function () {
            $state.go($state.current.name, { individual: vm.individual, all: vm.overview.data.showAll }, { reload: $state.current.name });
        };


        /* activation work */
        function activate() {
            //service
            vm.overview = ItemTableService;

            // init translation list
            vm.overview.init(vm.weekschemes);

        } //activate

    }
})();
